import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import ddt from '@wix/da-ddt';
import { toJsonString, isSSR } from '../utils';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { mergeEventDataWithContext } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
class Gak {
    logBi(eventData) {
        // Limit units to 2 logs max
        const loggedId = `${eventData.unitId}${eventData.evid}`;
        if (this.biLogged[loggedId] >= 2) {
            ddt.log('ads', 'Skip BI at limit', loggedId);
            return;
        }
        var _this_biLogged_loggedId;
        this.biLogged[loggedId] = ((_this_biLogged_loggedId = this.biLogged[loggedId]) !== null && _this_biLogged_loggedId !== void 0 ? _this_biLogged_loggedId : 0) + 1;
        if (!this.biContext) {
            this.logQueue.push(eventData);
            return;
        }
        biLogger.log(this.publicSession, mergeEventDataWithContext(eventData, this.biContext), false);
        this.flushBiQueue();
    }
    flushBiQueue() {
        if (this.logQueue.length > 0) {
            for (const item of this.logQueue){
                biLogger.log(this.publicSession, mergeEventDataWithContext(item, this.biContext), false);
            }
            this.logQueue = [];
        }
    }
    init() {
        if (!isSSR()) {
            try {
                var _window_googletag;
                // Replay events that happen before react lives
                if (window.__DAADS__ && Array.isArray(window.__DAADS__.ev)) {
                    for (const storedEvt of window.__DAADS__.ev){
                        ddt.log('ads', `gak boot evt ${storedEvt.ev}`, storedEvt === null || storedEvt === void 0 ? void 0 : storedEvt.e);
                        if (storedEvt.ev === 'slotRenderEnd') {
                            this.logBi(BiData(_object_spread({
                                evid: 8801,
                                unsafe: BiContextProvidedValue,
                                itemid: BiContextProvidedValue,
                                typeid: BiContextProvidedValue
                            }, this.biDataFromEvent(storedEvt.e))));
                        }
                    }
                    window.__DAADS__.ev = false;
                }
                // Listen for new events
                window['googletag'] = window['googletag'] || {
                    cmd: []
                };
                (_window_googletag = window['googletag']) === null || _window_googletag === void 0 ? void 0 : _window_googletag.cmd.push(()=>{
                    window['googletag'].pubads().addEventListener('slotRenderEnded', (e)=>{
                        this.logBi(BiData(_object_spread({
                            evid: 8801,
                            unsafe: BiContextProvidedValue,
                            itemid: BiContextProvidedValue,
                            typeid: BiContextProvidedValue
                        }, this.biDataFromEvent(e))));
                    });
                });
                window.addEventListener('pagehide', ()=>{
                    this.flushBiQueue();
                });
            } catch (e) {
                ddt.alertOnError(e, 'ads', 'Fatal in ads BI', [
                    'ads'
                ], e.message);
            }
        }
    }
    registerUnit(unitId, options, safety) {
        if (safety === 'off') {
            ddt.log('ads', 'Skipped register because ads are OFF', unitId);
            return;
        }
        if (!isSSR()) {
            ddt.log('ads', 'register gak client ad', unitId);
            window['DaGak'].registerAd(_object_spread({
                id: unitId
            }, options));
        } else {
            ddt.log('ads', 'register gak ssr ad', unitId);
            this.ssrUnits[unitId] = options;
        }
    }
    killUnit(unitId) {
        if (window['DaGak'] && window['DaGak'].killAd) {
            window['DaGak'].killAd(unitId);
        }
    }
    toSSR() {
        let output = '';
        for (const key of Object.keys(this.ssrUnits)){
            output = `${output}\nwindow["DaGak"].registerAd(JSON.parse(${toJsonString(_object_spread({
                id: key
            }, this.ssrUnits[key]))}));`;
        }
        return output;
    }
    setBiContext(context, session) {
        this.biContext = context;
        this.publicSession = session;
    }
    biDataFromEvent(e) {
        const { advertiserId , campaignId , companyIds , creativeId , creativeTemplateId , lineItemId , yieldGroupIds , isEmpty , size  } = e;
        const data = {
            unitId: e.slot.getSlotElementId(),
            isEmpty,
            size: Array.isArray(size) ? size.join(',') : '',
            advertiserId,
            campaignId,
            companyIds: Array.isArray(companyIds) ? companyIds.join(',') : '',
            creativeId,
            creativeTemplateId,
            lineItemId,
            yieldGroupIds: Array.isArray(yieldGroupIds) ? yieldGroupIds.join(',') : ''
        };
        return data;
    }
    constructor(){
        this.ssrUnits = {};
        this.logQueue = [];
        this.biLogged = {};
    }
}
export default Gak;
